import { useEffect } from 'react';

const SITE = 'Tread AI';
const DEFAULT_TITLE = 'Tread AI — Tire tread depth app for iPhone';

/** Per-page <title> and meta description for this single-page app. */
export function usePageMeta(title: string | null, description?: string) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE}` : DEFAULT_TITLE;
    if (description) {
      document.querySelector('meta[name="description"]')?.setAttribute('content', description);
      document.querySelector('meta[property="og:description"]')?.setAttribute('content', description);
    }
  }, [title, description]);
}
